<template>
  <div class="replace_manager_box">
    <el-form label-width="100px">
      <el-form-item label="现平台经理">
        <el-input :value="info.salesmanName" disabled></el-input>
      </el-form-item>
      <el-form-item label="新平台经理">
        <el-select
          v-model="salesmanPhone"
          placeholder="请选择平台服务经理"
          style="width: 100%;"
        >
          <el-option
            v-for="item in salesmanArr"
            :key="item.phone"
            :label="item.name"
            :value="item.phone"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div class="btn_row">
      <el-button type="primary" :loading="loading" @click="replaceManager"
        >确认替换</el-button
      >
    </div>
  </div>
</template>
<script>
import { salesmanList, updateSalesman } from "@/api/shipment";
export default {
  name: "ReplaceManager",
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      salesmanArr: [],
      salesmanPhone: "",
      loading: false
    };
  },
  created() {
    this.getSalesmanList();
  },
  methods: {
    async replaceManager() {
      if (this.loading) return;
      this.loading = true;
      try {
        let res = await updateSalesman({
          code: this.info.code,
          phone: this.salesmanPhone
        });
        if (res.status === 0) {
          this.$message({
            message: "替换成功",
            type: "success"
          });
        }
        console.log("返回结果==========", res);
      } finally {
        this.loading = false;
        this.$emit("updateList");
      }
    },
    getSalesmanList() {
      salesmanList({ branchCode: this.info.branchCode }).then(res => {
        if (res.status === 0) {
          console.log("======salesmanList", res);
          this.salesmanArr = res.data;
          // this.partyGroupOptions = res.data.records;
        }
      });
    }
  }
};
</script>
<style scoped>
.replace_manager_box {
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
}
.btn_row {
  text-align: center;
  margin-top: 12px;
}
.btn_row .el-button {
  width: 200px;
}
</style>
